// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-wrapper-model__title{margin-bottom:8px;color:var(--2yod4u);font-size:var(--yyc56v);font-weight:var(--1p34rfn);line-height:24px}.form-wrapper-model__form-wrapper{margin-bottom:16px}.form-wrapper-model__controls{display:flex;justify-content:center}.form-wrapper-model__button{width:100%}.form-wrapper-model__success{font-size:16px;line-height:24px}", ""]);
// Exports
module.exports = exports;
